module.exports = __webpack_public_path__ + "fonts/SeoulNamsanB.b7e9f637.otf";